import { z } from "zod";
import { TaskPriority, TaskType } from "./task";
import { TaskTemplateAssigneeRole } from "./taskTemplateAssigneeRole";

export {
    TaskTemplateAssigneeRole,
    ENGAGEMENT_TEAM_ROLES,
} from "./taskTemplateAssigneeRole";
export type { EngagementTeamRole } from "./taskTemplateAssigneeRole";

export enum TaskTemplateDeadlineAnchor {
    TODAY = "today",
    START_DATE = "start_date",
    END_DATE = "end_date",
    WORK_START_DATE = "work_start_date",
}

export const TaskTemplateSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    title: z.string(),
    description: z.string().nullable(),
    priority: z.nativeEnum(TaskPriority).nullable(),
    groupId: z.string().uuid().nullable(),
    assigneeId: z.number().int().nullable(),
    assigneeRole: z.nativeEnum(TaskTemplateAssigneeRole).nullable(),
    externalDeadline: z.number().int().min(0).nullable(),
    deadlineAnchor: z.nativeEnum(TaskTemplateDeadlineAnchor).nullable(),
    estimatedTime: z.number().int().min(0).nullable(),
    type: z.nativeEnum(TaskType).nullable(),
    initialMessage: z.string().nullable(),
    viewConfig: z.record(z.string(), z.any()).nullable(),
    closeTemplateId: z.string().uuid().nullable(),
    closeStageId: z.string().uuid().nullable(),
    order: z.number().int(),
    sourceTemplateId: z.string().uuid().nullable(),
    sourceTemplateVersion: z.number().int().min(1).nullable(),
    blockedByTaskTemplateIds: z.array(z.string().uuid()),
    relatedTaskTemplateIds: z.array(z.string().uuid()),
    createdByUserId: z.number().int().nullable(),
    updatedByUserId: z.number().int().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});

export type TaskTemplate = z.infer<typeof TaskTemplateSchema>;

export const TaskTemplatePreviewSchema = z.object({
    templateId: z.string().uuid(),
    title: z.string(),
    description: z.string().nullable(),
    priority: z.nativeEnum(TaskPriority).nullable(),
    groupId: z.string().uuid().nullable(),
    assigneeId: z.number().int().nullable(),
    assigneeRole: z.nativeEnum(TaskTemplateAssigneeRole).nullable(),
    externalDeadline: z.number().int().min(0).nullable(),
    deadlineAnchor: z.nativeEnum(TaskTemplateDeadlineAnchor).nullable(),
    estimatedTime: z.number().int().min(0).nullable(),
    type: z.nativeEnum(TaskType).nullable(),
    initialMessage: z.string().nullable(),
    closeStageId: z.string().uuid().nullable(),
});

export type TaskTemplatePreview = z.infer<typeof TaskTemplatePreviewSchema>;
